<script lang="ts">
	import { Text, Alert, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../../../helpers/utilities';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let options = [];
	export let value;
	export let action;
	export let isValid;

	export let onChange;

	let errorMessage = '';

	$: isValid = validateInput(value);
	/**
	 * Handle select option change
	 * @param {string} val
	 */
	function handleChange(val) {
		value = val;
		if (!isValid) {
			return;
		}
		onChange(val);
	}

	/**
	 * Validate user input and set error message if input is invalid
	 * @param {string} value
	 * @returns {bool} - true if input is valid
	 */
	function validateInput(val: string): boolean {
		if (options.find((item) => item.value === val) === undefined) {
			errorMessage = '';
			return false;
		}
		if (typeof val === 'undefined' || val === '') {
			errorMessage = $format('error_invalid_option', {
				default: 'The selected option has invalid properties. Please, select a valid option.',
			});
			return false;
		}
		errorMessage = '';
		return true;
	}
</script>

<Text element="h2" class="mb-s mt-l"
	>{capFirstChar(
		action?.title ||
			$format('title_scene_set_property_value', {
				default: 'Set {property} to',
				values: { property: action.name },
			}),
	)}</Text
>
{#if action?.alert}
	<Alert class="mb-s" heading={action?.alert} type={'warning'} />
{/if}

{#if errorMessage}
	<Alert class="mb-s" heading={errorMessage} type={'danger'} />
{/if}

<CardGrid sm={200} md={200} xl={200} noPaddingBottom>
	{#each options as _option, i}
		<div class="d-flex">
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				type="horizontal"
				variant="radio"
				title={_option?.title || $format('unknown_option', { default: 'Unknown option' })}
				icon={_option?.icon}
				selected={value === _option.value}
				on:click={() => {
					handleChange(_option.value);
				}}
			/>
		</div>
	{/each}
</CardGrid>
